export const maxFileSize = 30 * 1024; // 30 KB

export function validateFile(file: File | null): string | null {
  if (file) {
    if (!file.name.endsWith(".7z")) {
      return "Only library files with a '.7z' extension are allowed.";
    }

    if (file.size > maxFileSize) {
      return "File size exceeds the maximum limit of 30 KB.";
    }
  }
  return null;
}
